var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpbotton(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xEC\x97\x85 \xEB\xB2\x84\xED\x8A\xBC"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 226",
    d: "M0 25C0 11.1929 11.1929 0 25 0C38.8071 0 50 11.1929 50 25V50H25C11.1929 50 0 38.8071 0 25Z",
    fill: "#6C3F2E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.7651 29.4897C16.4699 29.2003 16.3223 28.8321 16.3223 28.3849C16.3223 27.9378 16.4699 27.5695 16.7651 27.2802L24.1722 20.0204C24.3332 19.8626 24.5076 19.7506 24.6955 19.6843C24.8834 19.619 25.0847 19.5864 25.2993 19.5864C25.514 19.5864 25.7223 19.6259 25.9241 19.7048C26.1249 19.7837 26.2923 19.8889 26.4265 20.0204L33.8336 27.2802C34.1288 27.5695 34.2764 27.9378 34.2764 28.3849C34.2764 28.8321 34.1288 29.2003 33.8336 29.4897C33.5384 29.779 33.1627 29.9237 32.7065 29.9237C32.2502 29.9237 31.8745 29.779 31.5793 29.4897L25.2993 23.3347L19.0194 29.4897C18.7242 29.779 18.3485 29.9237 17.8922 29.9237C17.436 29.9237 17.0603 29.779 16.7651 29.4897Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpbotton);
export default __webpack_public_path__ + "static/media/upbotton.68fe55436c53e1fdb82ce18be6aa2482.svg";
export { ForwardRef as ReactComponent };